import { render, staticRenderFns } from "./input-number-with-popover.vue?vue&type=template&id=ba89c9a2"
import script from "./input-number-with-popover.vue?vue&type=script&lang=js"
export * from "./input-number-with-popover.vue?vue&type=script&lang=js"
import style0 from "./input-number-with-popover.vue?vue&type=style&index=0&id=ba89c9a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports